export const SET_SUBJECT_FILTER = 'SET_SUBJECT_FILTER'
export const setSubjectFilter = (id) => ({
    type: SET_SUBJECT_FILTER,
    payload: id,
})

export const SET_SCHOOL_YEAR_FILTER = 'SET_SCHOOL_YEAR_FILTER'
export const setSchoolYearFilter = (id) => ({
    type: SET_SCHOOL_YEAR_FILTER,
    payload: id,
})

export const SET_LEVEL_FILTER = 'SET_LEVEL_FILTER'
export const setLevelFilter = (id) => ({
    type: SET_LEVEL_FILTER,
    payload: id,
})

export const RESET_FILTERS = 'RESET_FILTERS'
export const resetFilters = () => ({
    type: RESET_FILTERS,
})

export const SET_FILTERED_ITEMS = 'SET_FILTERED_ITEMS'
export const setFilteredItems = (items) => ({
    type: SET_FILTERED_ITEMS,
    payload: { items },
})
